<template>
	<v-dialog v-model="updateDialog" persistent max-width="500px">
		<v-card class="new-back lighten2">
			<v-card-title>
				<span class="headline">Update API Token</span>
			</v-card-title>
			<v-card-text v-if="token">
				<v-form ref="form" v-model="valid">
					<v-container>
						<v-row no-gutters>
							<v-col cols="12">
								<label>Name</label>
								<v-text-field :value="token.name" readonly filled dense/>
							</v-col>
							<v-col cols="12">
								<label>Description</label>
								<v-textarea v-model="tokenData.description" rows="2" outlined dense/>
							</v-col>
							<v-col cols="12">
								<label>Expiration</label>
								<v-text-field 
									:value="formatExpiration(token.expirationDateTime)" 
									readonly 
									filled 
									dense 
								/>
							</v-col>
							<v-col cols="12">
								<h3 class="mb-3">Permissions</h3>
								<v-expansion-panels v-model="expandedPanel" focusable accordion flat>
									<v-expansion-panel
										v-for="(permission) in permissions.filter(x => !x.deprecated)"
										:key="permission.id || permission.value" :readonly="!permission.children"
										class="bordered darken new-back"
									>
										<v-expansion-panel-header class="panel-header">
											<div>
												{{ permission.name }}
											</div>
											<template v-slot:actions>
												<div v-if="!permission.children">
													<access-level-select :value="getPermissionByValue(permission.value).accessLevel"
														:type="permission.levelTypes" @input="(v) => {
															if (permission) {
																let pem = getPermissionByValue(permission.value)
																pem.accessLevel = v
															}
														}" />
												</div>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content class="panel-content" v-if="permission.children">
											<div class="line" v-for="(subPermission, ix) in permission.children.filter(x => !x.deprecated)"
												:key="ix">
												<div class="line-title">{{ subPermission.name }}</div>
												<div class="content">
													<access-level-select :value="getPermissionByValue(subPermission.value).accessLevel"
														:type="subPermission.levelTypes" @input="(v) => {
															let pem = getPermissionByValue(subPermission.value)
															pem.accessLevel = v
														}" />
												</div>
											</div>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-col>
						</v-row>
					</v-container>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" text @click="closeUpdateDialog">Cancel</v-btn>
				<v-btn color="primary" @click="updateToken" :disabled="!valid">Update</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import AccessLevelSelect from '../AccessLevelSelect'
import moment from 'moment'

export default {
	components: {
		AccessLevelSelect
	},
	props: {
		permissions: {
			type: Array,
			required: true
		}
	},
	data:() => ({
		updateDialog: false,
		valid: false,
		token: null,
		tokenData: {
			description: '',
			permissions: []
		},
		expandedPanel: null,
	}),
	methods: {
		openUpdateDialog(token) {
			this.token = token;
			this.tokenData = {
				description: token.description || '',
				permissions: token.permissions ? JSON.parse(JSON.stringify(token.permissions)) : []
			};
			this.updateDialog = true;
		},
		closeUpdateDialog() {
			console.log('closeUpdateDialog');
			this.updateDialog = false;
			this.token = null;
			this.tokenData = {
				description: '',
				permissions: []
			};
		},
		getPermissionByValue(value) {
			if (!this.tokenData.permissions) {
				this.tokenData.permissions = [];
			}
			let perm = this.tokenData.permissions.find(p => p.type == value);
			if (!perm) {
				perm = { type: value, accessLevel: 0 };
				this.tokenData.permissions.push(perm);
			}
			return perm;
		},
		formatExpiration(expirationDateTime) {
			if (!expirationDateTime) {
				return 'Never';
			}
			return moment(expirationDateTime).format('YYYY-MM-DD');
		},
		updateToken() {
			if (!this.$refs.form.validate()) {
				window.getApp.error('Please fill all required fields');
				return;
			}

			const updateData = {
				description: this.tokenData.description,
				permissions: this.tokenData.permissions
			};

			this.$http.put(`/api/apiToken/${this.token.id}`, updateData)
				.then(res => {
					window.getApp.success("API token updated successfully.");
					this.$emit('save');
					this.closeUpdateDialog();
				})
				.catch(res => {
					window.getApp.error("Cannot update API token.");
					console.log(res);
				});
		},
	}
}

</script>
